<script setup lang="ts">
import { computed } from 'vue';

/**
 * Знак + слово, как на лендинге (LogoWithWord): «Step» жирным с плотным
 * трекингом, «VPN» ещё жирнее и градиентом сиреневый → розовый. Кегль задаёт
 * класс шрифта из пропа, начертание и градиент — этот компонент.
 */
const props = defineProps({
	image: {
		type: String,
		default: '/images/logo.svg'
	},
	name: {
		type: String,
		default: 'Step VPN'
	},
	font: {
		type: String,
		default: 'font-16-pro-regular'
	}
});

// Последнее слово названия — акцентное («VPN»); одно слово — без акцента
const words = computed(() => {
	const parts = props.name.trim().split(/\s+/);
	if (parts.length < 2) return { base: props.name, accent: '' };
	return { base: parts.slice(0, -1).join(' '), accent: parts[parts.length - 1] };
});
</script>

<template>
	<router-link to="/" class="part-app-logo" :aria-label="name">
		<img v-if="image" :src="image" alt="" class="part-app-logo__image">
		<span
			v-if="name"
			class="part-app-logo__name"
			:class="font"
			aria-hidden="true"
		>{{ words.base }}<template v-if="words.accent">{{ ' ' }}<span class="part-app-logo__accent">{{ words.accent }}</span></template></span>
	</router-link>
</template>

<style lang="scss">
.part-app-logo {
	display: flex;
	align-items: center;
	gap: 1rem;
	color: var(--color-text);

	&__image {
		flex: 0 0 auto;
		width: var(--logo-width, 4.2rem);
	}

	&__name {
		flex: 0 1 auto;
		font-weight: 700;
		letter-spacing: -0.02em;
		white-space: nowrap;
	}

	// Градиентный текст: фон обрезается по буквам, сами буквы прозрачные
	&__accent {
		font-weight: 800;
		background: linear-gradient(135deg, #a855f7, #ec4899);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
		color: transparent;
	}
}
</style>
